import { get, post } from '../request'
import type { UserInfo } from '../types'

/**
 * 认证 API
 * 来源: 文件34(API-DB-AUTH-BOUNDARIES) — 5个首批契约切片之一: Auth-Session
 */

export interface LoginResponse {
  token: string
  refreshToken?: string
  user: UserInfo
}

export const authApi = {
  /** POST /api/v1/auth/login */
  login(phone: string, password: string): Promise<LoginResponse> {
    return post('/auth/login', { phone, password })
  },

  /** GET /api/v1/me — 返回当前用户信息/角色/校区/端能力 */
  getMe(): Promise<UserInfo> {
    return get('/me')
  },

  /** POST /api/v1/auth/logout */
  logout(): Promise<void> {
    return post('/auth/logout')
  },

  /** POST /auth/refresh — 刷新Token */
  refresh(refreshToken: string): Promise<{ token: string; refreshToken: string }> {
    return post('/auth/refresh', { refreshToken })
  },

  /** POST /auth/change-password — 修改密码 */
  changePassword(data: { oldPassword: string; newPassword: string }): Promise<void> {
    return post('/auth/change-password', data)
  },

  /** POST /auth/first-login-change-password — 首次登录修改密码 */
  firstLoginChangePassword(data: { newPassword: string }): Promise<void> {
    return post('/auth/first-login-change-password', data)
  },
}
